<template>
  <div class="top">
    <NotLoggedIn v-if="user.user == null" class="top_not_logged_in" />
    <LoggedIn v-if="user.user != null" class="top_logged_in" />
  </div>
</template>

<script>
import NotLoggedIn from '@/components/top/NotLoggedIn.vue'
import LoggedIn from '@/components/top/LoggedIn.vue'

export default {
  name: 'Top',
  components: {
    NotLoggedIn,
    LoggedIn
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    }
  }
}
</script>
